<template>
  <div class="Ability">
    <div class="Ability-dv">
      <div class="Ability-dvh">
        <!-- <img src="../../assets/bg-chengzhang02.png" alt="" /> -->
        <qrcode-vue :value="qrcode" class="qrcode-stu" />
        <h1>能力成长记录</h1>
        <!-- <img :src="qrcode" alt="" /> -->
      </div>
    </div>
    <div class="Ability-dv1">
      <ul>
        <li v-for="(item, index) in list" :key="index">
          <div class="biaoti" />
          <span v-if="item.term == 2"
            >{{ item.grade }}-{{ item.grade + 1 }}学年 第二学期</span
          >
          <span v-if="item.term == 1"
            >{{ item.grade }}-{{ item.grade + 1 }}学年 第一学期</span
          >
          <div
            class="arrowshang"
            v-if="isActive1 == item.dataActive"
            @click="openshang(item.dataActive, item, index)"
          />
          <div
            class="arrowxia"
            v-else
            @click="open(item.dataActive, item, index)"
          />
          <transition name="hehe">
            <div class="Ability_content" v-if="isActive1 == item.dataActive">
              <div class="father">
                <div
                  v-for="(vo, i) in item.claims"
                  :key="i"
                  @click.stop="jumptab(i, vo.id, item, vo, index)"
                  class="content_li"
                >
                  <div class="tabcurrent" v-if="isActive == i" />
                  <div class="tabnormal" v-else />
                  <span :class="{ active: isActive == i }"
                    >毕业要求{{ vo.code }}</span
                  >
                </div>
              </div>
              <h3>“毕业要求{{ Numcode }}-{{ Kename }}”能力达成度分析</h3>

              <div>
                <abilityecharts
                  :pointLists="item.dataifon"
                  :showifon="item.off"
                  :id="`bar_${index}`"
                />
              </div>
              <h2>能力达成反馈</h2>
              <div class="Ability_fan" v-if="item.res.type1">
                <div class="fan_ul" id="son">
                  <div class="fan_li">
                    <SvgIcon icon-class="icontongguo" v-if="item.res.type1" />
                    <span :class="{ colorfont: item.res.type1 }">{{
                      item.res.type1
                    }}</span>
                    <p v-if="item.res.type1">{{ item.res.returnFeedback1 }}</p>
                  </div>
                </div>
              </div>
              <div class="Ability_fan" v-if="item.res.type2">
                <div class="fan_ul" id="son">
                  <div class="fan_li">
                    <SvgIcon icon-class="iconzhuyi" v-if="item.res.type2" />
                    <span :class="{ colorfont1: item.res.type2 }">{{
                      item.res.type2
                    }}</span>
                    <p v-if="item.res.type2">{{ item.res.returnFeedback2 }}</p>
                  </div>
                </div>
              </div>
              <div class="Ability_fan" v-if="item.res.type3">
                <div class="fan_ul" id="son">
                  <div class="fan_li">
                    <SvgIcon icon-class="iconyujing" v-if="item.res.type3" />
                    <span :class="{ colorfont2: item.res.type3 }">{{
                      item.res.type3
                    }}</span>
                    <p v-if="item.res.type3">{{ item.res.returnFeedback3 }}</p>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </li>
      </ul>
    </div>
    <back-to :path="'/'" />
  </div>
</template>
<script>
import backTo from "@/components/back";
import abilityecharts from "@/components/echaars/abilityecharts";
import api from "@/api";
import QrcodeVue from "qrcode.vue";
import config from "@/config";
export default {
  components: { backTo, abilityecharts, QrcodeVue },
  data() {
    return {
      chart: null,
      isActive: 0,
      isActive1: 0,
      grade: null,
      term: null,
      pointId: "",
      targetMark: [],
      name: [],
      ratioMark: [],
      pointcourse: [],
      Numcode: "",
      Kename: "",
      type1: "",
      returnFeedback1: "",
      type2: "",
      returnFeedback2: "",
      type3: "",
      returnFeedback3: "",
      pointList: [], //柱状图数据
      list: [],
      object: {},
      qrcode: ""
    };
  },
  created() {},
  mounted() {
    this.getQRcode();
    this.getAllGradeRef();
    // this.pointifon()
  },
  methods: {
    getQRcode() {
      const { Specials, userName } = JSON.parse(
        localStorage.getItem("userInfo")
      );

      if (!Specials.length)
        return (this.qrcode = `${
          config.BASE_API
        }/mobile/#/studentclaims?2016&747199723995136000&806612068441522176&719651428733288448&806612068407967744&719652232873639936&${encodeURI(
          "学生1"
        )}`);

      const classId = Specials[0].classId;
      const id = Specials[0].id;
      const specialtyId = Specials[0].specialtyId;
      const userId = Specials[0].userId;
      const versionId = Specials[0].versionId;
      const grade = Specials[0].grade;

      this.qrcode = `${
        config.BASE_API
      }/mobile/#/studentclaims?${grade}&${classId}&${id}&${specialtyId}&${userId}&${versionId}&${encodeURI(
        userName
      )}`;
    },
    open(ids, item, index) {
      this.isActive1 = ids;
      this.pointifon(item.claims[0].id, item.grade, item.term, index);
      if (item.showifon) {
        item.dataifon = {
          pointcourse: [],
          ratioMark: [],
          targetMark: [],
          name: []
        };
        item.res = {};
        this.pointifon(item.claims[0].id, item.grade, item.term, index);
      } else {
        item.off = false;
      }
      if (item.claims == undefined) {
        this.$toast({
          message: "暂时没有数据",
          position: "bottom"
        });
      }
    },
    openshang(ids) {
      this.isActive1 = !ids;
    },
    jumptab(i, ids, item, vo, index) {
      this.isActive = i;
      this.Kename = vo.name;
      this.Numcode = vo.code;
      item.off = false;
      this.pointifon(ids, item.grade, item.term, index);
    },
    getAllGradeRef() {
      this.$get(api.questionnaire.getAllGradeRef()).then(res => {
        if (res.status == 1) {
          // const data = {
          //   claims: [
          //     {
          //       name: "工程知识",
          //       id: "719662872505876480",
          //       code: "1",
          //       version_id: "719652232873639936",
          //       content:
          //         "具有从事机械工程领域工作所需的数学、自然科学、工程基础和专业知识，并能在分析和解决复杂工程问题中加以利用。"
          //     },
          //     {
          //       name: "问题分析",
          //       id: "719663875020029952",
          //       code: "2",
          //       version_id: "719652232873639936",
          //       content:
          //         "能够应用数学、自然科学和工程科学的基本原理，识别、表达并通过文献研究分析机电系统和部件设计、制造工艺、运动控制等复杂工程问题，并获得合理有效结论。"
          //     },
          //     {
          //       name: "设计/开发解决方案",
          //       id: "719664212443398144",
          //       code: "3",
          //       version_id: "719652232873639936",
          //       content:
          //         "具有针对机电工程领域中的复杂系统、部件、控制过程和工艺流程的设计／开发能力，能够在设计环节中体现创新意识并考虑社会、健康、安全、法律、文化及环境等因素。"
          //     },
          //     {
          //       name: "研究",
          //       id: "719665007930900480",
          //       code: "4",
          //       version_id: "719652232873639936",
          //       content:
          //         "具有运用科学原理和科学方法开展复杂机械工程问题研究及实验的能力，能够对研究及实验结果进行分析并通过信息综合得到合理有效的结论。"
          //     },
          //     {
          //       name: "使用现代工具",
          //       id: "719665163124342784",
          //       code: "5",
          //       version_id: "719652232873639936",
          //       content:
          //         "在复杂机械工程活动中，具有选择和运用技术、资源和信息工具进行工程实践的能力。"
          //     },
          //     {
          //       name: "工程与社会",
          //       id: "719665278845190144",
          //       code: "6",
          //       version_id: "719652232873639936",
          //       content:
          //         "能够评价机械工程实践和复杂工程问题解决方案对健康、安全、法律和文化问题的影响，并理解应承担的责任。"
          //     },
          //     {
          //       name: "环境和可持续发展",
          //       id: "719665390254292992",
          //       code: "7",
          //       version_id: "719652232873639936",
          //       content:
          //         "能够理解和评价针对复杂工程问题的机械工程实践对环境、社会可持续发展的影响。"
          //     },
          //     {
          //       name: "职业规范",
          //       id: "719665753594265600",
          //       code: "8",
          //       version_id: "719652232873639936",
          //       content:
          //         "具有人文社会科学素养、社会责任感，能够在工程实践中理解并遵守工程职业道德和规范，履行责任。"
          //     },
          //     {
          //       name: "个人和团队",
          //       id: "719665885849059328",
          //       code: "9",
          //       version_id: "719652232873639936",
          //       content:
          //         "具有团队合作精神和在多学科交叉环境中发挥个人作用的能力。"
          //     },
          //     {
          //       name: "沟通",
          //       id: "719666044054011904",
          //       code: "10",
          //       version_id: "719652232873639936",
          //       content:
          //         "具有在复杂机械工程活动中与业界同行和社会公众进行有效沟通的能力，具备一定的国际视野和跨文化交流的能力。"
          //     },
          //     {
          //       name: "项目管理",
          //       id: "719666158285881344",
          //       code: "11",
          //       version_id: "719652232873639936",
          //       content:
          //         "理解并掌握机械工程管理原理与经济决策方法，并能在多学科环境中应用。"
          //     },
          //     {
          //       name: "分解",
          //       id: "850060823257677824",
          //       code: "11",
          //       version_id: "719652232873639936",
          //       content: ""
          //     },
          //     {
          //       name: "终身学习",
          //       id: "719666288837787648",
          //       code: "12",
          //       version_id: "719652232873639936",
          //       content:
          //         "了解本专业前沿发展现状和趋势，具有终生教育的意识和不断学习的能力。"
          //     }
          //   ],
          //   yearTerm: [
          //     {
          //       term: 2,
          //       grade: 2012
          //     },
          //     {
          //       term: 1,
          //       grade: 2016
          //     },
          //     {
          //       term: 2,
          //       grade: 2016
          //     },
          //     {
          //       term: 1,
          //       grade: 2017
          //     },
          //     {
          //       term: 2,
          //       grade: 2017
          //     },
          //     {
          //       term: 1,
          //       grade: 2018
          //     },
          //     {
          //       term: 2,
          //       grade: 2018
          //     },
          //     {
          //       term: 1,
          //       grade: 2020
          //     },
          //     {
          //       term: 2,
          //       grade: 2021
          //     }
          //   ]
          // };
          const data = res.data;
          data.yearTerm.forEach(item => {
            data.claims.forEach(element => {
              element.tabcurrents = false;
            });
            item.claims = data.claims;
            item.dataActive = Number(`${item.grade}${item.term}`);
            item.off = false;
            item.dataifon = {
              pointcourse: [],
              ratioMark: [],
              targetMark: [],
              name: []
            };
            item.res = {};
            item.showifon = false;
          });
          this.Kename = data.claims[0].name;
          this.Numcode = data.claims[0].code;
          this.list = data.yearTerm;
          this.grade = this.list[0].grade;
          this.term = this.list[0].term;
          this.pointId = this.list[0].claims[0].id;
        }
      });
    },
    pointifon(a, b, c, index) {
      this.$get(api.questionnaire.getpoint(a, b, c)).then(element => {
        this.object = element.data;
        if (element.status == 1) {
          const obj = {
            pointcourse: [],
            ratioMark: [],
            targetMark: [],
            name: []
          };
          element.data.avgRatioList.forEach(item => {
            obj.name.push(item.name);
            obj.targetMark.push(item.targetMark);
            obj.ratioMark.push(item.ratioMark);
            obj.pointcourse.push(item.point_course_mark);
          });
          this.$set(this.list[index], "dataifon", obj);
          this.$set(this.list[index], "res", element.data);
          this.$set(this.list[index], "off", true);
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.qrcode-stu {
  padding: 1rem 2rem;
}
.Ability {
  .Ability-dv {
    .Ability-dvh {
      width: 100%;
      height: 318px;
      background: url("../../assets/bg-chengzhang02.png") no-repeat center
        center;
      background-size: 100% 100%;
      h1 {
        position: absolute;
        right: -60px;
        top: 160px;
        transform: translate(-50%, -50%);
        font-size: 40px;
        font-family: PingFangSC;
        font-weight: 600;
        color: rgba(255, 255, 255, 1);
        // letter-spacing: 5px;
        display: block;
      }
      img {
        width: 100%;
        height: 318px;
      }
    }
  }
  .Ability-dv1 {
    width: 100%;
    position: absolute;
    top: 270px;
    padding: 0 24px;
    .hehe-enter,
    .hehe-leave-to {
      opacity: 0;
    }
    .hehe-enter-to,
    .hehe-start {
      opacity: 0.5;
    }
    .hehe-enter-start,
    .hehe-leave {
      opacity: 1;
    }
    .hehe-enter-active,
    .hehe-leave-active {
      transition: ease-in 0.2s;
    }
    ul {
      li {
        list-style: none;
        background: rgba(255, 255, 255, 1);
        box-shadow: $box-shadow;
        border-radius: 10px;
        padding: 40px 30px;
        margin-bottom: 30px;
        img {
          width: 40px;
          height: 22px;
          margin-right: 10px;
        }
        img:nth-child(3) {
          width: 30px;
          height: 30px;
          float: right;
          margin-top: 10px;
        }
        .arrowshang {
          float: right;
          width: 30px;
          height: 30px;
          background: url("../../assets/arrow-shang.png") no-repeat center
            center;
          background-size: 100% 100%;
          margin-top: 10px;
        }
        .arrowxia {
          margin-top: 10px;
          float: right;
          width: 30px;
          height: 30px;
          background: url("../../assets/arrow-xia.png") no-repeat center center;
          background-size: 100% 100%;
        }
        .biaoti {
          margin-top: 10px;
          float: left;
          width: 45px;
          height: 25px;
          margin-right: 15px;
          background: url("../../assets/dian-biaoti2.png") no-repeat center
            center;
          background-size: 100% 100%;
        }
        span {
          font-size: 30px;
          font-family: PingFangSC;
          font-weight: 700;
          color: rgba(50, 50, 50, 1);
        }
        .Ability_content {
          .className1 {
            width: 100%;
            height: 500px;
            margin-top: 50px;
          }
          .father {
            display: flex;
            overflow-x: auto;
            -ms-overflow-style: none;
            overflow: -moz-scrollbars-none;
            margin-bottom: 40px;
            &::-webkit-scrollbar {
              width: 0 !important;
              height: 0 !important;
            }
            .content_li {
              min-width: 33%;
              flex: 1;
              position: relative;
              padding: 0;
              box-shadow: none;
              margin-top: 30px;
              img {
                width: 100%;
                height: 110px;
              }
              .tabcurrent {
                width: 100%;
                height: 110px;
                margin-right: 15px;
                background: url("../../assets/tab-current.png") no-repeat center
                  center;
                background-size: 100% 100%;
              }
              .tabnormal {
                width: 100%;
                height: 110px;
                margin-right: 15px;
                background: url("../../assets/tab-normal.png") no-repeat center
                  center;
                background-size: 100% 100%;
              }
              span {
                font-size: 24px;
                font-family: PingFangSC;
                font-weight: 600;
                color: #969696;
                position: absolute;
                top: 35px;
                left: 45px;
              }
              .active {
                color: rgba(255, 255, 255, 1);
              }
            }
          }
          h3 {
            font-size: 30px;
            font-family: PingFangSC;
            font-weight: 700;
            color: #323232;
            text-align: center;
          }
          h2 {
            font-size: 30px;
            font-family: PingFangSC;
            font-weight: 700;
            color: #323232;
            text-align: center;
            margin-top: 20px;
          }
          .Ability_fan {
            .fan_ul {
              margin-top: 30px;
              .fan_li {
                list-style: none;
                padding: 0;
                box-shadow: none;
                margin-bottom: 60px;
                img {
                  width: 64px;
                  height: 64px;
                  float: left;
                }
                svg {
                  width: 60px;
                  height: 50px;
                }
                span {
                  font-size: 24px;
                  font-family: PingFangSC;
                  font-weight: 500;
                  margin-left: 15px;
                  margin-top: 15px;
                  display: inline-block;
                }
                .colorfont {
                  color: $color-primary;
                }
                .colorfont1 {
                  color: #fec744;
                }
                .colorfont2 {
                  color: #fd6162;
                }
                p {
                  font-size: 20px;
                  font-family: PingFangSC;
                  font-weight: 400;
                  color: rgba(150, 150, 150, 1);
                  margin-top: 50px;
                  line-height: 36px;
                  text-align: left;
                }
                .fan_dv {
                  margin-top: 35px;
                  padding-left: 6px;
                  .fan_dv1 {
                    padding: 16px 48px;
                    background: rgba(244, 244, 244, 1);
                    border-radius: 10px;
                    display: inline-block;
                    margin-right: 20px;
                    font-size: 24px;
                    font-family: PingFangSC;
                    font-weight: 400;
                    color: rgba(150, 150, 150, 1);
                    margin-bottom: 20px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
